/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Deep_P2Inputs */

const en_to_xml_deep_p2 = /** @type {(inputs: To_Xml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Character replacement alone is not enough, because a key such as 2nd survives it unchanged and still cannot start an element name. Such names get an underscore prefix, so 2nd becomes _2nd. This matters because the alternative is output that looks fine, copies cleanly, and then fails at the first parse on the other side, which is a considerably worse outcome than a slightly ugly name.`)
};

const ko_to_xml_deep_p2 = /** @type {(inputs: To_Xml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문자 치환만으로는 부족합니다. 2nd 같은 키는 치환을 그대로 통과하면서도 여전히 요소 이름을 시작할 수 없기 때문입니다. 그런 이름에는 밑줄 접두사가 붙어 2nd가 _2nd가 됩니다. 이것이 중요한 이유는, 대안이 보기에는 괜찮고 깔끔하게 복사되지만 상대편에서 첫 파싱에 실패하는 출력이라는 점입니다. 조금 보기 나쁜 이름보다 훨씬 나쁜 결과입니다.`)
};

const ja_to_xml_deep_p2 = /** @type {(inputs: To_Xml_Deep_P2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字の置換だけでは足りません。2nd のようなキーは置換をそのまま通り抜けながら、依然として要素名を始められないからです。そうした名前にはアンダースコアの接頭辞が付き、2nd は _2nd になります。これが重要なのは、代替案が、見た目は問題なくきれいにコピーできて、相手側の最初のパースで失敗する出力だからです。少し見苦しい名前よりずっと悪い結果です。`)
};

/**
* | output |
* | --- |
* | "Character replacement alone is not enough, because a key such as 2nd survives it unchanged and still cannot start an element name. Such names get an undersco..." |
*
* @param {To_Xml_Deep_P2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_deep_p2 = /** @type {((inputs?: To_Xml_Deep_P2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Deep_P2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_deep_p2(inputs)
	if (locale === "ko") return ko_to_xml_deep_p2(inputs)
	return ja_to_xml_deep_p2(inputs)
});